import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {RentalPropertyInfoComponent} from "../rental-property-info/rental-property-info.component";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {EnrollmentComponent} from "../enrollment-request/EnrollmentComponent";
import {EnrollmentModel} from "../../domain/models/enrollment.model";
import {EnrollmentRentalPropertyModel} from "../../domain/models/enrollment-rental-property.model";

@Component({
  selector: 'app-individual-bed-rental',
  standalone: true,
  imports: [
    RentalPropertyInfoComponent,
    FormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule
  ],
  templateUrl: './individual-bed-rental.component.html',
  styleUrl: './individual-bed-rental.component.css'
})
export class IndividualBedRentalComponent implements OnInit, EnrollmentComponent {
  @Input() enrollment!: EnrollmentModel;
  @ViewChild(RentalPropertyInfoComponent) rental: RentalPropertyInfoComponent | undefined;
  additionalInfoForm!: FormGroup;
  rentalProperty!: EnrollmentRentalPropertyModel;

  constructor(private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.rentalProperty = this.enrollment.enrollmentRentalProperty?? {};
    this.buildForm(this.enrollment)
  }

  buildForm(info: EnrollmentModel | undefined): void {
    this.additionalInfoForm = this.fb.group({
      businessSign: [this.enrollment.businessDbaName?? '', Validators.required],
      webSiteUrl: [this.enrollment.enrollmentRentalProperty?.webUrl?? '']
    });
  }

  getUpdatedEnrollment(): EnrollmentModel {
    return {
      webSiteUrl: this.additionalInfoForm.value.webSiteUrl,
      enrollmentRentalProperty: this.rental?.getFormData()
    };
  }

  isFormValid(): boolean {
    return this.additionalInfoForm.valid
      && (this.rental?.isFormValid()?? false);
  }

  raiseFormValidations(): void {
    this.additionalInfoForm.markAllAsTouched();
    this.rental?.raiseFormValidations();
  }
}
